import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/mail_gray_60.png'
import _imports_1 from '@/assets/icons/person_dotted_80.png'
import _imports_2 from '@/assets/icons/person_gray_150.png'


const _withScopeId = n => (_pushScopeId("data-v-3115f808"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "member-history" }
const _hoisted_2 = {
  key: 0,
  class: "member-task share-invite done"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_4 = { class: "task-done" }
const _hoisted_5 = {
  key: 0,
  class: "cancelled"
}
const _hoisted_6 = { class: "task-date" }
const _hoisted_7 = {
  key: 0,
  class: "task-actor"
}
const _hoisted_8 = {
  key: 1,
  class: "member-task share done"
}
const _hoisted_9 = { class: "task-icon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_11 = {
  key: 0,
  src: _imports_2
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-done" }, " Profile shared ", -1))
const _hoisted_13 = { class: "task-date" }
const _hoisted_14 = {
  key: 0,
  class: "task-actor"
}
const _hoisted_15 = {
  key: 2,
  class: "member-task invite done"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_17 = { class: "task-done" }
const _hoisted_18 = {
  key: 0,
  class: "cancelled"
}
const _hoisted_19 = { class: "task-date" }
const _hoisted_20 = {
  key: 0,
  class: "task-actor"
}
const _hoisted_21 = {
  key: 3,
  class: "member-task joined done"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-done" }, " Joined group ", -1))
const _hoisted_24 = { class: "task-date" }

import { computed } from 'vue'
import { PotentialMember } from './FamilyGroupMemberManager'
import { DateTimeUtil } from '@/util/LuxonUtil'
import { useUserStore } from '@/gp/UserStore'
import { LoadMode } from '@/util/AsyncData'
import { InvitationResult } from '@/gp/GroupAdminModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupMemberHistory',
  props: {
    familyGroupId: {},
    pm: {}
  },
  emits: ["removeProfile", "viewGroupInvite", "viewSharingInvite"],
  setup(__props: any, { emit }) {

const props = __props;





const userStore = useUserStore()

const sharingInviteByRef = computed(() => userStore.getAsyncUser(props.pm.lastSharingInvite?.senderUserId, LoadMode.EnsureLoaded)?.data)
const sharedByRef = computed(() => userStore.getAsyncUser(props.pm.sharedProfileMember?.modifiedUserId, LoadMode.EnsureLoaded)?.data)
const groupInviteByRef = computed(() => userStore.getAsyncUser(props.pm.lastGroupInvite?.senderUserId, LoadMode.EnsureLoaded)?.data)


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.pm.lastSharingInvite?.isPending)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(" Share profile requested "),
              (_ctx.pm.lastSharingInvite.result == _unref(InvitationResult).Cancelled)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(cancelled)"))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-inline btn-link",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('viewSharingInvite', _ctx.pm.lastSharingInvite!.id!)))
              }, " View ")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(DateTimeUtil).toRelativePastDate(_ctx.pm.lastSharingInvite?.lastSentDate)), 1),
              (sharingInviteByRef.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createTextVNode(" by "),
                    _createVNode(_component_router_link, {
                      to: sharingInviteByRef.value.pageUrl
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(sharingInviteByRef.value.displayName), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (props.pm.isProfileShared)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            (_ctx.pm.isProfileShared)
              ? (_openBlock(), _createElementBlock("img", _hoisted_11))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _hoisted_12,
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(DateTimeUtil).toRelativePastDate(_ctx.pm.sharedProfileMember?.modifiedDate)), 1),
              (sharedByRef.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                    _createTextVNode(" by "),
                    _createVNode(_component_router_link, {
                      to: sharedByRef.value.pageUrl
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(sharedByRef.value.displayName), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.pm.lastGroupInvite)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_17, [
              _createTextVNode(" Invited to join "),
              (_ctx.pm.lastGroupInvite?.result == _unref(InvitationResult).Cancelled)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "(cancelled)"))
                : _createCommentVNode("", true),
              (_ctx.pm.lastGroupInvite)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-inline btn-link",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('viewGroupInvite', _ctx.pm.lastGroupInvite.id!)))
                  }, " View "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(DateTimeUtil).toRelativePastDate(_ctx.pm.lastGroupInvite?.lastSentDate)), 1),
              (groupInviteByRef.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                    _createTextVNode(" by "),
                    _createVNode(_component_router_link, {
                      to: groupInviteByRef.value.pageUrl
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(groupInviteByRef.value.displayName), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.pm.member)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", null, [
            _hoisted_23,
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(DateTimeUtil).toRelativePastDate(_ctx.pm.member?.createdDate)), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})